import { PushRegistrationSchema } from 'schemas/PushRegistration'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = PushRegistrationSchema

export const url = ({ providerId }) => `/v1/providers/${providerId}/notification/register`

export const getBody = ({ registration }) => registration
